/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
// import { FindOneOptions, FindOptions } from './common';
import { CreateProductProposalPolicyData } from './productProposalPolicy';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/proposal-policies';

export const ProposalPolicyApi = {
  find: async (option: any = {}) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: any = {}) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: CreateProposalPolicyData) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: any = {}) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  duplicate: async (id: string, body: DuplicateProposalPolicyBody) => {
    const url = `${pathname}/duplicate/${id}`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (options: {
    code: string;
    proposalPolicyOwnerID: string;
  }) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateProposalPolicyData {
  name: string;
  ownerID: string;
  productProposalPolicies: Pick<
    CreateProductProposalPolicyData,
    Exclude<keyof CreateProductProposalPolicyData, 'proposalPolicyID'>
  >[];
  customerIDs: string[];
}

export interface DuplicateProposalPolicyBody {
  name: string;
  chainEntityIDs?: string[];
}
